import {
  instoreTypesSelectors,
  fetchInstoreTypesAsync,
} from "../features/instoreTypes/instoreTypesSlice";
import { useAppDispatch, useAppSelector } from "../store/configureStore";
import { useEffect } from "react";
import useActiveWeekInstoreTemplates from "./useActiveWeekInstoreTemplates";
import resolveWeekTemplateForStoreFormat from "../helpers/resolveWeekTemplateForStoreFormat";
import { InstoreTemplate } from "../models/instoreTemplate";

// The active "Week" template available for a store's format. A store format
// belongs to one instore type, and there is normally one Week template per
// type. Returns undefined when no format is given or nothing matches.
export default function useActiveWeekInstoreTemplateForStore(
  storeFormatId?: number | null,
): InstoreTemplate | undefined {
  const dispatch = useAppDispatch();
  const { instoreTypes_Loaded } = useAppSelector((state) => state.instoreTypes);
  const instoreTypes = useAppSelector(instoreTypesSelectors.selectAll);
  const weekTemplates = useActiveWeekInstoreTemplates();

  useEffect(() => {
    if (!instoreTypes_Loaded) dispatch(fetchInstoreTypesAsync());
  }, [instoreTypes_Loaded, dispatch]);

  return resolveWeekTemplateForStoreFormat(
    weekTemplates,
    instoreTypes,
    storeFormatId,
  );
}
